import { render, staticRenderFns } from "./TakipHazirlaBetaView.vue?vue&type=template&id=2153b0eb"
import script from "./TakipHazirlaBetaView.vue?vue&type=script&lang=ts"
export * from "./TakipHazirlaBetaView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports